"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WALLET_ADAPTERS = exports.CHAIN_NAMESPACES = exports.ADAPTER_EVENTS = exports.Web3Auth = void 0;
var base_1 = require("@web3auth/base");
Object.defineProperty(exports, "ADAPTER_EVENTS", { enumerable: true, get: function () { return base_1.ADAPTER_EVENTS; } });
Object.defineProperty(exports, "CHAIN_NAMESPACES", { enumerable: true, get: function () { return base_1.CHAIN_NAMESPACES; } });
Object.defineProperty(exports, "WALLET_ADAPTERS", { enumerable: true, get: function () { return base_1.WALLET_ADAPTERS; } });
var core_1 = require("@web3auth/core");
var openlogin_adapter_1 = require("@web3auth/openlogin-adapter");
var configs_1 = require("../configs");
var types_1 = require("../types");
var number_1 = require("../utils/number");
var wallet_1 = require("../wallet");
var Web3Auth = /** @class */ (function () {
    function Web3Auth() {
    }
    Web3Auth.prototype._init = function (chain) {
        return __awaiter(this, void 0, void 0, function () {
            var openloginAdapter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.web3auth = new core_1.Web3AuthCore({
                            enableLogging: false,
                            clientId: configs_1.authConfig.clientId,
                            chainConfig: {
                                chainNamespace: chain.chainNamespace,
                                chainId: (0, number_1.getHexFromDecimal)(chain.chainId),
                                displayName: chain.name,
                                rpcTarget: chain.rpcUrl,
                                ticker: chain.currencySymbol,
                                tickerName: chain.currencyName,
                                blockExplorer: chain.blockExplorerUrl,
                            },
                        });
                        openloginAdapter = this.getOpenLoginAdapter(chain.isMainnet);
                        this.web3auth.configureAdapter(openloginAdapter);
                        return [4 /*yield*/, this.web3auth.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.web3auth];
                }
            });
        });
    };
    Web3Auth.prototype.getOpenLoginAdapter = function (isMainnet) {
        return new openlogin_adapter_1.OpenloginAdapter({
            adapterSettings: {
                clientId: configs_1.authConfig.clientId,
                network: isMainnet ? 'mainnet' : 'testnet',
                uxMode: 'popup',
            },
        });
    };
    Web3Auth.prototype.connect = function (loginProvider) {
        return __awaiter(this, void 0, void 0, function () {
            var provider, privateKey, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.web3auth) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.web3auth.connectTo(base_1.WALLET_ADAPTERS.OPENLOGIN, {
                                loginProvider: loginProvider,
                                mfaLevel: 'default',
                            })];
                    case 2:
                        provider = _a.sent();
                        if (!provider) {
                            throw new types_1.ErrorGeneric(types_1.errorType.ErrorGeneric);
                        }
                        return [4 /*yield*/, (provider === null || provider === void 0 ? void 0 : provider.request({ method: 'eth_private_key' }))];
                    case 3:
                        privateKey = (_a.sent());
                        return [2 /*return*/, new wallet_1.WalletFactory().createWalletFromPrivateKey(privateKey)];
                    case 4:
                        error_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(error_1)];
                    case 5: return [3 /*break*/, 7];
                    case 6: throw new types_1.ErrorSDKInitialization(types_1.errorType.ErrorSDKInitialization);
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    Web3Auth.prototype.getUser = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.web3auth) === null || _a === void 0 ? void 0 : _a.getUserInfo())];
                    case 1:
                        user = _b.sent();
                        if (user) {
                            return [2 /*return*/, { email: user.email, loginProvider: user.typeOfLogin, address: '' }];
                        }
                        return [2 /*return*/, user];
                }
            });
        });
    };
    Web3Auth.prototype.logout = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                (_a = this.web3auth) === null || _a === void 0 ? void 0 : _a.logout();
                return [2 /*return*/];
            });
        });
    };
    return Web3Auth;
}());
exports.Web3Auth = Web3Auth;
